import { useState } from 'react';
import Cookies from 'js-cookie';

import { Drawer, Button, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import {
  RootState,
  isExternalUrl,
  getPreferenceFromAccount,
  getLocalURI,
  isAnyReservationCancelFromPath,
  IsImpersonating,
  GetHomeParams,
  GetWalletNumber,
  UrlUtils,
  isBlogFromPath,
  isResultsFromPath,
  isCondoBookFromPath,
  isBookFromPath,
  isChangePasswordFromPath,
  isErrorFromPath,
  isSavedPropertiesFromPath,
  isReservationsFromPath,
} from '@share/utils';
import { endImpersonation, loginActions, logout, setLoginLoading, setLoginRedirect } from '@share/store/slices';
import { LoginType } from '@share/utils';
import {
  IAccount,
  ISideKickStatus,
  LOGOUT_FIELD_KEY,
} from '@share/common-types';
import { COOKIE1_TOKEN_NAME, COOKIE_TOKEN_NAME, Routes } from '@share/constants';
import { WhiteButton } from '@components';

import { UserSvg } from '@assets';
import { CloseSvg } from '@share/assets';

import { BlueButton } from '@share/components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { GiftCard } from '../gift-card';

import './style.scss';

interface IProps {
  matches?: boolean;

  isShowCredits: boolean;
}

export function HeaderWelcome(props: IProps) {

  const [showDrawerUserInfo, setShowDrawerUserInfo] = useState(false);

  const dispatch = useDispatch();

  const history = useHistory();
  const intl = useIntl();

  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);
  const hotelsStore = useSelector((state: RootState) => state.hotelsStore);
  
  const { hotels } = hotelsStore;
  const { account, user, userWallet, userWalletData, widgetRedirect } = loginStore;
  const { items, menuList } = menuStore;

  const showUserLinks = () => {
    setShowDrawerUserInfo(true);
  };

  const onCloseUserLinks = () => {
    setShowDrawerUserInfo(false);
  };

  const handleEndImpersonation = () => {
    dispatch(endImpersonation());
  };

  const handleLogout = () => {
    const isPublicAccountType = account?.type === LoginType.Public;
    const isPrivateWithLogin = account?.type === LoginType.PrivateWithLogin;

    const widgetLogoutRedirect = account?.widgetLogoutRedirect;
    const hasClientCash = account?.hasClientCash;
    const isAshevillePlay = account?.isAshevillePlay;

    const widgetRedirectStore = widgetRedirect;
    const widgetRedirectUrl = widgetLogoutRedirect;
    const widgetRedirectFinal = widgetRedirectStore || widgetRedirectUrl;
    const disableSignInRedirect = account?.disableSignInRedirect;
    const isDisableSignIn = account?.isDisableSignIn;

    if (isPrivateWithLogin) {
      if(widgetRedirectFinal &&!isEmpty(widgetRedirectFinal)) {
        window.location.replace(widgetRedirectFinal);
        dispatch(logout());
        return;
      }
      
      if (isDisableSignIn && disableSignInRedirect && !isEmpty(disableSignInRedirect)) {
        window.location.replace(account.disableSignInRedirect);
        dispatch(logout());
        return;
      }
    }

    dispatch(logout());

    if ((!isPublicAccountType || !hasClientCash) && !isAshevillePlay) {
      hangleGoToLogin();
    }

    if (isAshevillePlay) {      
      dispatch(loginActions.setForceLoading(true));

      history.push(`/${account?.name}${Routes.Search}`);

      window.location.reload();
    }
  };

  const hangleGoToLogin = () => {
    const { pathname, search } = history.location;
    dispatch(setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`));

    history.push(`/${account?.name}${Routes.Login}`);
  };

  const handleLogoutToken = () => {
    Cookies.remove(COOKIE_TOKEN_NAME);
    Cookies.remove(COOKIE1_TOKEN_NAME);
  };

  const renderLogout = () => {
    const hasClientCash = account?.hasClientCash;
    const isCapitalVacations = account?.isCapitalVacations;
    const isRSITemplate = account?.isRSITemplate;

    if (isCapitalVacations && !account?.isCapitalVacationsAgent) {
      return <div className="header__user-drawer-btn-wrapper" style={{ padding: '10px' }}></div>;
    }

    const isPrivateLoginAccountType = account?.type === LoginType.PrivateWithLogin;
    const isLogged = !!userWallet;

    if (!isPrivateLoginAccountType && !(!isRSITemplate && hasClientCash && isLogged) && !isAshevillePlay) {
      const logoutURLPref = getPreferenceFromAccount(account as IAccount, LOGOUT_FIELD_KEY);
      const logoutUrl =
        account?.type === LoginType.PrivateWithToken
          ? !isEmpty(items?.logoutUrl)
            ? items?.logoutUrl
            : !isEmpty(logoutURLPref)
            ? logoutURLPref
            : null
          : null;

      return (
        <a
          href={logoutUrl as string}
          onClick={handleLogoutToken}
          className="header__user-drawer-btn-wrapper"
        >
          <WhiteButton>
            <FormattedMessage id="log.out" />
          </WhiteButton>
        </a>
      );
    } else {

      return (
        <div onClick={handleLogout} className="header__user-drawer-btn-wrapper">
          <WhiteButton>
            <FormattedMessage id="log.out" />
          </WhiteButton>
        </div>
      );
    }
  };

  const { matches, isShowCredits } = props;

  const isPublicAccountType = account?.type === LoginType.Public;
  const isPrivateLoginAccountType = account?.type === LoginType.PrivateWithLogin;
  const isPrivateTokenAccountType = account?.type === LoginType.PrivateWithToken;
  const isCancelRoute = isAnyReservationCancelFromPath(history);
  const isImpersonating = IsImpersonating();

  const isBlogPage = isBlogFromPath(history);
  const isSearchPage = isResultsFromPath(history);
  const isBookPage = isBookFromPath(history);
  const isChangePasswordPage = isChangePasswordFromPath(history);
  const isErrorPage = isErrorFromPath(history);
  const isSavedPropertiesPage = isSavedPropertiesFromPath(history);
  const isReservationsPage = isReservationsFromPath(history);

  const hasClientCash = account?.hasClientCash;
  const isRSITemplate = account?.isRSITemplate;
  const isAshevillePlay = account?.isAshevillePlay;

  const isAfterSearchLoad = isSearchPage && (hotels && !!hotels.length);
  const isAshevillePlayHeader = isAshevillePlay && ((isSearchPage && isAfterSearchLoad) || isBookPage || isBlogPage || isChangePasswordPage || isErrorPage || isSavedPropertiesPage || isReservationsPage);

  const isLoggedAshevillePlay = isAshevillePlay && !user?.isAshevillePlayAdmin;
  const isLogged = !!userWallet || isLoggedAshevillePlay;

  const loggedUser = !hasClientCash || isLoggedAshevillePlay ? user : userWallet;

  if (
    matches &&
    (!isPublicAccountType || (isAshevillePlay && isLoggedAshevillePlay) || (hasClientCash && isLogged)) &&
    !!loggedUser &&
    !isCancelRoute
  ) {
    const isCapitalVacations = account?.isCapitalVacations;
    const isCapitalVacationsCondoRes = account?.isCapitalVacationsCondoRes;

    const fontFamily = account?.fontFamily;
    const secondaryFontFamily = account?.secondaryFontFamily;
    const headerFontColor = account?.headerFontColor;
    const headerHideMemberId = account?.headerHideMemberId;
    const headerMainMenu = account?.headerMainMenu;
    const headerHideMemberUserIdDrawer = account?.headerHideMemberUserIdDrawer;
    const headerTextUpperCase = account?.headerTextUpperCase;
    const headerFullDrawer = account?.headerFullDrawer;

    const homeParams = GetHomeParams(account as IAccount);

    const isParentSidekick = items?.sideKickStatus === ISideKickStatus.PARENT;

    const style = !isEmpty(headerFontColor) ? { color: isAshevillePlayHeader ? '#000000' : headerFontColor } : {};
    const styleBurger = !isEmpty(headerFontColor) ? { background: isAshevillePlayHeader ? '#000000' : headerFontColor } : {};
    const styleMainMenuDrawer: any = headerTextUpperCase ? { textTransform: 'uppercase' } : {};

    if (!items?.isTravelAgent && account?.levartiOrgIds?.includes(items?.organizationId as number)) {
      return (
        <div className="header__user-info">
          <a
            href="https://team.golevarti.com/Cart/ShoppingCart/product/PASSPRO-US-ACT-EXM"
            target="_blank"
          >
            <BlueButton style={{ lineHeight: '40px' }}>
              <FormattedMessage id="become.travel.agent" />
            </BlueButton>
          </a>
        </div>
      );
    }

    return (
      <div className="header__user-info">
        <p className="header__user-info-item" style={style}>
          {isImpersonating && account?.isTravelAgentPro && 'You are signed in as '}
          {!loggedUser ? items?.firstName : loggedUser?.firstName}{' '}
          {!loggedUser ? items?.lastName[0] : loggedUser?.lastName}
          {(isImpersonating && account?.isTravelAgentPro) && (
            <Button onClick={handleEndImpersonation} type="text" danger size={'small'}>
              End impersonation
            </Button>)}
          {(!isAshevillePlay && !headerHideMemberId && items?.rsiId && !(hasClientCash && isLogged) && !items?.isMLM) ? (
            <span style={{ fontSize: '12px' }}>
              {'\n'}
              <FormattedMessage id="id" />
              {': '}
              {items?.rsiId}
            </span>) : null}
          {(!headerHideMemberId && items?.email && items?.isMLM) ? (
            <span style={{ fontSize: '12px' }}>
              {'\n'}
              {items?.email}
            </span>) : null}
        </p>

        {items?.isPromoSite || (!!isShowCredits && !account?.isMLM) ? (
          <p className="header__user-info-credits secondary-font">{items?.leisureCredits}</p>
        ) : null}

        <div onClick={showUserLinks} className="header__user-hamburger-btn">
          {matches ? (
            <>
              <span className="header__user-hamburger-item" style={styleBurger} />
              <span className="header__user-hamburger-item" style={styleBurger} />
              <span className="header__user-hamburger-item" style={styleBurger} />
            </>
          ) : (
            <UserSvg />
          )}
        </div>

        <Drawer
          className={`header__user-drawer ${headerFullDrawer ? 'full-drawer' : ''} ${!showDrawerUserInfo ? 'hide' : ''} ${fontFamily ? `${fontFamily}-font`: ''} ${secondaryFontFamily ? `secondary-${secondaryFontFamily}-font`: ''}`}
          placement="right"
          closable={true}
          onClose={onCloseUserLinks}
          headerStyle={{ display: 'none' }}
          open={showDrawerUserInfo}
          closeIcon={<CloseSvg />}
        >
          {(!headerHideMemberUserIdDrawer || 
            (!headerHideMemberId && items?.isMLM) || 
            (!headerHideMemberId && !(hasClientCash && isLogged) && !items?.isMLM) || 
            (hasClientCash && isLogged) || 
            (!!isShowCredits && !account?.isMLM)) && (
              <div className="header__user-drawer-wrapper">
                <div className="header__user-drawer-info">
                  {!headerHideMemberUserIdDrawer && (
                    <p className="header__user-drawer-name secondary-font">
                      {!loggedUser ? items?.firstName : loggedUser?.firstName}{' '}
                      {!loggedUser ? items?.lastName[0] : loggedUser?.lastName}
                    </p>)}

                  {(!headerHideMemberId && items?.isMLM) ? <p className="header__user-drawer-member">{items?.email}</p> : null}

                  {(!isAshevillePlay && !headerHideMemberId && !(hasClientCash && isLogged) && !items?.isMLM) ? (
                    <p className="header__user-drawer-member">
                      <FormattedMessage
                        id={
                          isCapitalVacations ? 
                              isCapitalVacationsCondoRes ? 
                                  'condores.ID' : 
                                  'owner.ID' : 
                              'member.ID'
                        }
                      />
                      {': '}
                      {items?.rsiId}
                    </p>) : null}

                  {hasClientCash && isLogged ? (
                    <>
                      <p className="header__user-drawer-member">
                        <FormattedMessage
                          id="wallet.menu.active_cash"
                          values={{
                            clientCash: isEmpty(account?.walletClientCashName)
                              ? 'Client Cash'
                              : account?.walletClientCashName,
                          }}
                        />
                        {': '}
                        {GetWalletNumber(userWalletData?.balance as number, account)}{' '}
                        <Tooltip
                          title={intl.formatMessage(
                            { id: 'wallet.menu.active_cash.tooltip' },
                            {
                              clientCash: isEmpty(account?.walletClientCashName)
                                ? 'Client Cash'
                                : account?.walletClientCashName,
                            },
                          )}
                        >
                          <FontAwesomeIcon icon={faCircleInfo} />
                        </Tooltip>
                      </p>
                      {!account?.walletIsExternal ? (
                        <p className="header__user-drawer-member">
                          <FormattedMessage
                            id="wallet.menu.pending_cash"
                            values={{
                              clientCash: isEmpty(account?.walletClientCashName)
                                ? 'Client Cash'
                                : account?.walletClientCashName,
                            }}
                          />
                          {': '}
                          {GetWalletNumber(userWalletData?.pendingBalance as number, account)}{' '}
                          <Tooltip
                            title={intl.formatMessage(
                              { id: 'wallet.menu.pending_cash.tooltip' },
                              {
                                clientCash: isEmpty(account?.walletClientCashName)
                                  ? 'Client Cash'
                                  : account?.walletClientCashName,
                              },
                            )}
                          >
                            <FontAwesomeIcon icon={faCircleInfo} />
                          </Tooltip>
                        </p>
                      ) : null}
                    </>
                  ) : null}
                </div>
                {!!isShowCredits && !account?.isMLM ? (
                  <p className="header__user-drawer-credits secondary-font">{items?.leisureCredits}</p>
                ) : null}
              </div>)}

          {(headerMainMenu && menuList?.length) && (
            <div className="header__user-drawer-links">
              {menuList.map((item: any, index: number) =>
                isExternalUrl(item.url as string) ? (
                  <a
                    key={`${item.title}${index}`}
                    className="header__user-drawer-link"
                    href={item.url}
                    onClick={onCloseUserLinks}
                    style={styleMainMenuDrawer}
                  >
                    <FormattedMessage id={item.title} />
                  </a>
                ) : (
                  <Link
                    key={`${item.title}${index}`}
                    className="header__user-drawer-link"
                    to={`/${account?.name}${getLocalURI(item.url as string)}`}
                    onClick={onCloseUserLinks}
                    style={styleMainMenuDrawer}
                  >
                    <FormattedMessage id={item.title} />
                  </Link>
                ),
              )}
            </div>)}

          {items?.user ? (
            <div className="header__user-drawer-links">
              {items?.user.map((item: any, index: number) =>
                isExternalUrl(item.url as string) ? (
                  <a
                    key={`${item.title}${index}`}
                    className="header__user-drawer-link"
                    href={item.url}
                    onClick={onCloseUserLinks}
                  >
                    <FormattedMessage id={item.title} />
                  </a>
                ) : (
                  <Link
                    key={`${item.title}${index}`}
                    className="header__user-drawer-link"
                    to={`/${account?.name}${getLocalURI(item.url as string)}`}
                    onClick={onCloseUserLinks}
                  >
                    <FormattedMessage id={item.title} />
                  </Link>
                ),
              )}
            </div>
          ) : null}

          {isPrivateTokenAccountType &&
          !account?.isCapitalVacationsCondoRes &&
          ((!isRSITemplate || items?.showMyAccount) && !((headerMainMenu && menuList?.length))) ? (
            <div className="header__user-drawer-links">
              <Link
                className="header__user-drawer-link"
                to={`/${account?.name}${Routes.RsiAccount}${homeParams}`}
                onClick={onCloseUserLinks}
              >
                <FormattedMessage id={'my.account.title'} />
              </Link>
            </div>
          ) : null}

          {isPrivateTokenAccountType && account?.isCapitalVacations ? (
            <div className="header__user-drawer-links">
              <Link
                className="header__user-drawer-link"
                to={`/${account?.name}${Routes.RsiAccount}/reservations${homeParams}`}
                onClick={onCloseUserLinks}
              >
                <FormattedMessage id={'reservation.search.title'} />
              </Link>
            </div>
          ) : null}

          {isPrivateLoginAccountType ||
          (isPrivateTokenAccountType && !account?.isCapitalVacations && !items?.showMyAccount) ||
          (hasClientCash && isLogged && !account?.isCapitalVacations) ||
          (isAshevillePlay && isLoggedAshevillePlay) ? (
            <div className="header__user-drawer-links">
              <Link
                className="header__user-drawer-link"
                to={`/${account?.name}${Routes.Reservations}${homeParams}`}
                onClick={onCloseUserLinks}
              >
                <FormattedMessage id="reservation.search.title" />
              </Link>

              {!items?.isMLM && !account?.isCapitalVacations && (
                <Link
                  className="header__user-drawer-link"
                  to={`/${account?.name}${Routes.SavedPropertiesAccount}`}
                  onClick={onCloseUserLinks}
                >
                  <FormattedMessage id="saved.properties" />
                </Link>)}

              {!items?.isMLM && !account?.isCapitalVacations && (
                <Link
                  className="header__user-drawer-link"
                  to={`/${account?.name}${Routes.ChangePassword}`}
                  onClick={onCloseUserLinks}
                >
                  <FormattedMessage id="change.password" />
                </Link>)}

              {items?.isMLM && isParentSidekick ? (
                <Link
                  className="header__user-drawer-link"
                  to={`/${account?.name}${Routes.RsiTestDriveManager}`}
                  onClick={onCloseUserLinks}
                >
                  {!isEmpty(items?.sideKickShortName) ? (
                    items?.sideKickShortName
                  ) : (
                    <FormattedMessage id="test.drive.manager" />
                  )}
                </Link>
              ) : null}
            </div>
          ) : null}

          <GiftCard isDrawer />

          {renderLogout()}
        </Drawer>
      </div>
    );
  }

  return null;
}
